import React from 'react';
import '../../EmergencyWidget.css';

const List = ({ initialData = { volunteers: { medic: [], paramedic: [], maar: [] } }, title = 'חירום והצלה', showTitle = true }) => {
  const volunteers = initialData.volunteers || { medic: [], paramedic: [], maar: [] };

  const getSimchaConfig = (type) => {
    const configs = {
      medic: {
        label: 'חובש',
        icon: 'medical_services',
        color: '#D32F2F',
        bg: '#FFEBEE'
      },
      paramedic: {
        label: 'פרמדיק',
        icon: 'cardiology',
        color: '#C62828',
        bg: '#FFCDD2'
      },
      maar: {
        label: 'מע"ר',
        icon: 'healing',
        color: '#D32F2F',
        bg: '#FFEBEE'
      }
    };
    return configs[type] || { label: 'כונן', icon: 'support', color: '#D32F2F', bg: '#FFEBEE' };
  };

  const allVolunteers = [
    ...(volunteers.medic || []).map(v => ({ ...v, type: 'medic' })),
    ...(volunteers.paramedic || []).map(v => ({ ...v, type: 'paramedic' })),
    ...(volunteers.maar || []).map(v => ({ ...v, type: 'maar' }))
  ];

  return (
    <div style={{
      padding: '20px',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          borderBottom: '1px solid #FFCDD2',
          paddingBottom: '12px',
          marginBottom: '15px'
        }}>
          <div style={{
            backgroundColor: '#FFEBEE',
            borderRadius: '50%',
            padding: '6px',
            display: 'flex',
            border: '1px solid #FFCDD2'
          }}>
            <span className="material-symbols-outlined" style={{ color: '#C62828', fontSize: '24px' }}>ambulance</span>
          </div>
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: '#B71C1C',
            fontSize: '20px',
          }}>{title}</h3>
        </div>
      )}

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '12px',
        alignContent: 'flex-start'
      }}>
        {allVolunteers.length === 0 ? (
          <div style={{ width: '100%', textAlign: 'center', color: '#B71C1C', marginTop: '20px' }}>אין כוננים זמינים</div>
        ) : (
          allVolunteers.map((volunteer, index) => {
            const config = getSimchaConfig(volunteer.type);
            return (
              <div
                key={volunteer.id || index}
                style={{
                  backgroundColor: '#fff',
                  backgroundImage: 'linear-gradient(to bottom right, #fff, #FFF5F5)',
                  padding: '16px',
                  borderRadius: '8px',
                  border: '1px solid #FFCDD2',
                  boxShadow: '0 2px 4px rgba(183, 28, 28, 0.1)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px'
                }}
              >
                <div style={{
                  fontSize: '11px',
                  color: config.color,
                  fontWeight: 'bold',
                  backgroundColor: config.bg,
                  width: 'fit-content',
                  padding: '2px 8px',
                  borderRadius: '4px'
                }}>
                  {config.label}
                </div>

                <div style={{
                  fontSize: '18px',
                  color: '#3E2723',
                  fontWeight: 'bold',
                }}>
                  {volunteer.name}
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  color: '#B71C1C',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}>
                  <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>call</span>
                  {volunteer.phone}
                </div>

                {volunteer.address && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    color: '#795548',
                    fontSize: '12px'
                  }}>
                    <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>location_on</span>
                    {volunteer.address}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default List;